<template>
  <svg
    stroke="currentColor"
    :class="customStyle"
    viewBox="0 0 26 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4211 11.6152C17.4211 10.7029 17.9053 8.87835 19.8421 8.87835M19.8421 8.87835C21.779 8.87835 22.2983 10.3871 22.3684 11.2994C23.1053 11.2643 24.6842 11.931 24.6842 13.6152C24.6842 15.2994 23.2105 15.8608 22.4737 15.931C19.4912 15.931 13.3368 15.931 12.579 15.931C11.6316 15.931 9.3158 14.8784 9.3158 12.2468C9.3158 9.61519 12.1579 8.66782 12.7895 8.87835C12.8947 7.72046 13.7158 5.40466 16.1579 5.40466C19.2105 5.40466 19.8421 7.82572 19.8421 8.87835Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M16.1579 5.40467C15.5263 4.1766 13.3158 1.72046 9.52632 1.72046C4.78947 1.72046 1 5.40467 1 9.50993C1 13.6152 1 13.6152 1 17.4047C1 21.1941 4.36842 25.4047 9.31579 25.4047C14.2632 25.4047 17.7368 21.4047 17.7368 17.4047V15.931"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M14.6842 15.931V16.4157C14.6842 19.3312 12.4994 22.2468 9.38789 22.2468C6.27634 22.2468 4.15784 19.1778 4.15784 16.4157C4.15784 13.6536 4.15784 13.6536 4.15784 10.6613C4.15784 7.66899 6.54115 4.98361 9.5203 4.98361C11.4568 4.98361 12.7377 6.16554 13.363 7.08888"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <mask
      id="path-4-inside-1_147_7079"
      fill="currentColor"
    >
      <ellipse
        cx="20.579"
        cy="19.0889"
        rx="1.26316"
        ry="1.26316"
      />
    </mask>
    <path
      d="M20.3421 19.0889C20.3421 18.9581 20.4481 18.852 20.579 18.852V21.852C22.105 21.852 23.3421 20.6149 23.3421 19.0889H20.3421ZM20.579 18.852C20.7098 18.852 20.8158 18.9581 20.8158 19.0889H17.8158C17.8158 20.6149 19.0529 21.852 20.579 21.852V18.852ZM20.8158 19.0889C20.8158 19.2197 20.7098 19.3257 20.579 19.3257V16.3257C19.0529 16.3257 17.8158 17.5628 17.8158 19.0889H20.8158ZM20.579 19.3257C20.4481 19.3257 20.3421 19.2197 20.3421 19.0889H23.3421C23.3421 17.5628 22.105 16.3257 20.579 16.3257V19.3257Z"
      fill="currentColor"
      mask="url(#path-4-inside-1_147_7079)"
    />
    <mask
      id="path-6-inside-2_147_7079"
      fill="currentColor"
    >
      <ellipse
        cx="23.5263"
        cy="24.352"
        rx="1.26316"
        ry="1.26316"
      />
    </mask>
    <path
      d="M23.2895 24.352C23.2895 24.2212 23.3955 24.1152 23.5263 24.1152V27.1152C25.0524 27.1152 26.2895 25.8781 26.2895 24.352H23.2895ZM23.5263 24.1152C23.6571 24.1152 23.7632 24.2212 23.7632 24.352H20.7632C20.7632 25.8781 22.0003 27.1152 23.5263 27.1152V24.1152ZM23.7632 24.352C23.7632 24.4828 23.6571 24.5889 23.5263 24.5889V21.5889C22.0003 21.5889 20.7632 22.826 20.7632 24.352H23.7632ZM23.5263 24.5889C23.3955 24.5889 23.2895 24.4828 23.2895 24.352H26.2895C26.2895 22.826 25.0524 21.5889 23.5263 21.5889V24.5889Z"
      fill="currentColor"
      mask="url(#path-6-inside-2_147_7079)"
    />
    <path
      d="M24.7895 17.8257L19.3158 25.7205"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'OptimizeIcon',
  props: {
    customStyle: {
      type: String,
      default: 'w-5 h-5',
    },
  },
}
</script>
